export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14198.dc2e1a7b.jpg";